const useUrlIframeBankIds = ["1011", "855"];

const emailRequiredBankIds = ["855", "856"];

const validateLuhn = (cardNumber) => {
  const sanitized = cardNumber.replace(/\D/g, "");
  let sum = 0;
  let shouldDouble = false;

  for (let i = sanitized.length - 1; i >= 0; i--) {
    let digit = parseInt(sanitized.charAt(i), 10);

    if (shouldDouble) {
      digit *= 2;
      if (digit > 9) digit -= 9;
    }

    sum += digit;
    shouldDouble = !shouldDouble;
  }

  return sum % 10 === 0;
};

export { useUrlIframeBankIds, emailRequiredBankIds, validateLuhn };
